<template>
  <div id="boxFixed">
      <div @click="topgo" v-if="topflag" style="width: 25px;height: 25px;position: fixed;bottom: 39px;right: 12px;z-index: 2000000;border-radius:50%;background:#fff">
        <svg style="width:25px;height:25px" @click="topgo" t="1657514538127" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14561" width="200" height="200"><path d="M537.6 275.2c-12.8-12.8-32-12.8-44.8 0L307.2 454.4c-12.8 12.8-12.8 32 0 44.8 12.8 12.8 32 12.8 44.8 6.4l128-128v422.4c0 19.2 12.8 32 32 32s32-12.8 32-32V377.6l128 128c12.8 6.4 32 6.4 44.8 0 12.8-12.8 12.8-32 0-44.8L537.6 275.2z" p-id="14562" fill="#03a9f4"></path><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512-230.4-512-512-512z m0 960c-249.6 0-448-198.4-448-448s198.4-448 448-448 448 198.4 448 448-198.4 448-448 448z" p-id="14563" fill="#03a9f4"></path></svg>
      </div>
      <van-nav-bar
        :title="obj.org_name"
        left-arrow
        @click-left="onClickLeft"
        />
        <div class="switchimg" style="background:#fff">
            <van-swipe @change="onChange">
                <van-swipe-item v-for="(item,index) in data" :key="index">
                    <img style="width:100%;height:100%" @click="showimg(item.src)" :src="item.src" alt="">
                </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator">{{ current + 1 }}/{{data.length}}</div>
            </template>
            </van-swipe>
        </div>
        <div style="height:100px;background:#f2f2f2;display:flex;flex-direction:column;align-items:center;justify-content:center">
            <div class="btn" @click="open">
                申请试听
            </div>
            <p style="font-size:12px;color:#606266;margin-top:3px" v-if="giftflag">预约礼：{{obj.org_info.gift?obj.org_info.gift:''}}</p>
        </div>
        <div>
            <div class="view_card courseWrap" style="margin-top:8px;background:#fff">
      <div class="courseWrap_header">
        <span>课程介绍</span>
      </div>
      <ul class="courseList">
        <li class="left" v-for="(item,index) in obj.courseInfo" :key="index" @click="jump1(item)">
            <div class="imgWrap">
            <van-image fit="cover" :src="item.cover_img" alt="" lazy-load>
                <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                </template>
            </van-image>
            </div>
            <div class="courseList_info">
            <p class="courseList_info-title ellipsis" title="">{{item.title}}</p>
            <p class="explain">适合月龄：{{item.minimum_month_age}}-{{item.maximum_month_age}}个月</p>
            <p class="intro" title="">{{item.brief}}</p>
            </div>
        </li>
      </ul>
      <div v-if="courflag" style="text-align:center">暂无</div>
  </div>
  <div class="view_card teacherWrap" style="margin-top:8px;background:#fff">
        <div class="teacherWrap_header">
            <span>师资介绍</span>
        </div> 
        <div class="teacherList">
      <div class="teacherItem" v-for="(item,index) in obj.teacherInfo" :key="index" @click="jump2(item)">
        <van-image
          width="2.5rem"
          height="2.5rem"
          shape="square"
          :size="100"
          :src="item.photo"
          fit="cover"
          lazy-load
        >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <p class="name">{{item.full_name}}</p>
        <p style="color:black">{{item.teach_age}}年教龄</p>
      </div>
    </div>
    <div v-if="teaflag" style="text-align:center">暂无</div>
    </div> 
    <div class="view_card" style="margin-top:8px;background:#fff">
    <p class="title">联系我们</p>
    <div class="contact_item">
      <div>
        <div style="display:flex">
          <p style="font-size:12px;color:#666;">{{obj.org_info?obj.org_info.business_info:''}}</p>
          <p style="margin-left:20px;display:block;font-size:12px;color:#666">{{obj.org_info?obj.org_info.category==1?'亲子教育':obj.org_info.category==2?'托育机构':'亲子游泳':''}}</p>
        </div>
        <div style="display:flex;margin-top:15px" v-if="obj.org_info">
          <div style="font-size:10px;color:#666;background:#bcbcbc;padding:3px 4px;color:#fff;border-radius:5px;box-sizing:border-box" :class="index!=0?'act':''" v-for="(item,index) in obj.org_info.label" :key="index">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="contact_item">
      <a style="color:#666" :href="`https://uri.amap.com/marker?position=${wzinfo.longitude},${wzinfo.latitude}&name=${wzinfo.address}`">{{ wzinfo.address }}（距离<span class="dist">{{ wzinfo.distance }}</span>）</a>
    </div>
  </div>
                <div class="big">
                    <div class="usWrap">
                        <div class="usCont">
                        <div class="headTitle">
                            <div class="title_img"></div>
                            <p>关于我们</p>
                            <div class="title_img"></div>
                        </div>
                        <div style="max-width:100%!important;overflow-x:hidden" class="content btmBrief" v-html="obj.about_us"></div>
                        </div>
                    </div>
                </div>
            <div style="height:100px;background:#f2f2f2;display:flex;flex-direction:column;align-items:center;justify-content:center">
                <span style="color:#606266;font-size:12px">京ICP备14010996号</span>
                <a href="https://www.weizaojiao.cn">
                <span style="color:#606266;font-size:12px;margin-top:8px">北京融入网络科技有限公司</span>
                </a>
            </div>
        </div>
        <van-popup v-model="popflag" position="bottom" :style="{ height: '60%' }">
            <div style="width:95%;height:98%;margin:auto;margin-top:1%;overflow: hidden;">
                <div style="width: 50%;margin: auto;text-align: center;margin-top:8px;margin-bottom:8px">请注册并提交信息</div>
                <div>
                    <van-field v-model="valuename1" label="宝宝昵称" placeholder="请输入宝宝昵称" size="mini"/>
                    <van-field style="margin-top:10px" v-model="valuename2" label="家长姓名" placeholder="请输入家长姓名"  size="mini"/>
                    <van-field style="margin-top:10px" v-model="phone" @change="all" label="手机号"  type="number" placeholder="请输入11位手机号" size="mini" />
                    <van-field
                        v-model="sms"
                        center
                        type="digit"
                        clearable
                        label="短信验证码"
                        @change="all"
                        style="margin-top:10px"
                        placeholder="请输入短信验证码"
                        >
                        <template #button>
                            <p style="color:#03a9f4" name="btn1" v-if="djflag" @click="getcode" size="small" type="primary">获取验证码</p>
                            <p style="color:#03a9f4" name="btn2" v-else size="small" type="primary">重新发送{{smss}}</p>
                        </template>
                    </van-field>
                    <div style="margin-left:5%;margin-top:10px">
                        <van-checkbox v-model="checked" icon-size="14px" size="mini"><div style="font-size:12px">已阅读并同意<span style="color:#03a9f4" @click="jumper(1)">《平台协议》</span>和<span style="color:#03a9f4" @click="jumper(2)">《隐私政策》</span></div></van-checkbox>
                        <span style="font-size:10px;margin-top:8px">提交后该商家将看到您的预留信息，将进一步和您取得联系并为您服务</span>                        
                    </div>
                    <div style="display:flex;justify:center;margin-top:10px">
                        <van-button style="background:#03a9f4;color:#fff;margin:auto" size="small" :disabled="jiny" @click="submit">提交</van-button>
                    </div>
                    <!-- <div class="amite" @click="submit">提交</div> -->
                </div>
            </div>
        </van-popup>
  </div>
</template>
<script type="text/javascript">var bbt_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");document.write(unescape("%3Cscript%20src%3D%27" + bbt_protocol + "g.kexin001.com/statics/js/bbt-ext-track.js%3F7718_c97991cc8f5d4bf087ac0246569eb99e%27%20type%3D%27text/javascript%27%3E%3C/script%3E"));</script>
<script>
import {ImagePreview,Toast } from 'vant';
import course from '../pages/introduction.vue'
export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
        course,
        Toast
    },
    data (){
        return {
            current: 0,
            data:[],
            show: false,
            index: 0,
            allnum:0,
            popflag:false,
            valuename1:'',
            valuename2:'',
            sms:'',
            smss:60,
            djflag:true,
            checked:false,
            org:'',
            obj:{},
            showflag:1,
            phone:"",
            jiny:true,
            courflag:false,
            teaflag:false,
            wzinfo:{},
            lat1:'',
            lng1:'',
            agree:1,
            topflag:false,
            topop:0,
            giftflag:false
        }
    },
    activated(){
        this.org = this.$route.query.id
        this.getdata()   
    },
    created(){
        var that = this
        new BMap.Geolocation().getCurrentPosition(
        function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        //通过Geolocation类的getStatus()可以判断是否成功定位。
        sessionStorage.setItem('lng',r.point.lng)
        sessionStorage.setItem('lat',r.point.lat)
        that.lat = r.point.lat
        that.lng = r.point.lng
        new BMap.Geocoder().getLocation(r.point, function (rs) {
        var addComp = rs.addressComponents;
        });
        }
        },

        { enableHighAccuracy: true }
        );
        this.listenerFunction();
    },
    mounted(){
        this.showflag = this.$route.query.show
        this.agree = this.$route.query.is_agree
        this.allnum = this.data.length
         this.getdata()       
        sessionStorage.setItem('sphere',this.$route.query.sphere)
    },
    watch:{
        smss(newval,oldval){
            if(newval<1){
                this.djflag = true
                clearInterval(this.timer)
                this.smss = 60
            }
        },
        sms(newval,oldval){
            if(newval!==''&&this.phone!==''&&this.checked==true){
              this.jiny = false
            }else{
              this.jiny = true
            }
        },
        phone(newval,oldval){
          if(newval!==''&&this.sms!==''&&this.checked==true){
              this.jiny = false
            }else{
              this.jiny = true
            }
        },
        checked(newval,oldval){
          if(newval){
            this.jiny = false
          }else{
            this.jiny = true
          }
        },
        topop(newval,oldval){
          console.log(newval)
        }

    },
    methods: {
      listenerFunction(e) {
        document.addEventListener('scroll', this.handleScroll, true);
      },
      handleScroll () {
        document.addEventListener('scroll', this.handleScroll, true);
        if(document.documentElement.scrollTop>500){
          this.topflag = true
        }
        if(document.documentElement.scrollTop==0){
          this.topflag = false
        }
        },
        topgo(){
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        },
        all(){
          // if(this.sms==''||this.phone==''){
          //   console.log(11)
          // }
        },
        onClickLeft () {
            this.$router.back('/homedetail')
        },
        gohome(){
            var org = sessionStorage.getItem('org_from')
            var type = sessionStorage.getItem('type')
            this.$router.push('/publichome'+'?origin='+org+'&category='+type)
        },
        getjw(){
            
        },
        jump1(i){
            this.$router.push('/coursedetail'+'?org_id='+this.org)
            sessionStorage.setItem('arr',JSON.stringify(i))
        },
        jump2(i){
            this.$router.push('/teacher')
            sessionStorage.setItem('org',this.org)
            sessionStorage.setItem('arr2',JSON.stringify(i))
        },
        onClickLeft() {
            var org = sessionStorage.getItem('org_from')
            var type = sessionStorage.getItem('type')
            this.$router.push('/publichome'+'?origin='+org+'&category='+type)
        },
        onChange(index) {
            this.current = index;
        },
        showimg(src){
            ImagePreview([src]);
        },
        open(){
            this.popflag = true
        },
        djs(){
            
        },
        opendj(){
            this.smss--
        },
        jumper(status){
            if(status==1){
                this.$router.push('/agreement'+'?status=1')
            }else{
                this.$router.push('/agreement')
            }
        },
        getdata(){
            let params = {
                org_id:this.org,
                latitude:sessionStorage.getItem('lat'),
                longitude:sessionStorage.getItem('lng'),
                is_agree:this.agree
            }
            this.$ajax('/App/PublicSphere/orgInfo',params).then(res=>{
              if(res.code==400){
                return false
              }
              this.data=[]
                res.data.envImg.forEach(item=>{
                    this.data.push({
                        src:item
                    })
                })
                this.wzinfo = res.data.org_info
                if(res.data.org_info.gift==''){
                  this.giftflag = false
                }else{
                  this.giftflag = true
                }
                this.obj = res.data
                sessionStorage.setItem('shop',this.obj.org_name)
                if(this.obj.courseInfo.length==0){
                    this.courflag = true
                }else{
                    this.courflag = false
                }
                if(this.obj.teacherInfo.length==0){
                    this.teaflag = true
                }else{
                    this.teaflag = false
                }
            })
        },
        getcode(){
            if(this.phone==''){
                Toast('请填写手机号')
                return false
            }
            let params = {
                phone:this.phone,
                org_id:this.org
            }
            this.$ajax('/App/PublicSphere/verifyCode',params).then(res=>{
                if(res.code!=400){
                    Toast(res.msg)
                    this.djflag = false
                    this.timer = setInterval(this.opendj, 1000)
                }else{
                    Toast(res.msg)
                }
                
            
            })
        },
        submit(){
            if(this.valuename1==''||this.valuename2==''||this.phone==''||this.sms==''){
                Toast('请完善您的信息')
                return false
            }

            if(this.checked==false){
                Toast('请您阅读并同意平台协议以及隐私政策')
                return false
            }
            let params = {
                org_id:this.org,
                babyname:this.valuename1,
                username:this.valuename2,
                phone:this.phone,
                code:this.sms,
                is_read:this.checked?1:2,
                sphere_id:this.$route.query.sphere
            }
           this.$ajax('/App/PublicSphere/bookingAudition',params).then(res=>{
               if(res.code==200){
                   this.popflag = false
                   this.valuename1 = ''
                   this.valuename2 = ''
                   this.phone = ''
                   this.sms = ''
                   this.checked = false
                   var fromto = sessionStorage.getItem('org_from')
                   if(fromto=="baobaoshu"){
                   _btp.push(['_trackEvent', 10002])
                   }
                   clearInterval(this.timer)
               }
                Toast(res.msg)
           })
        }
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon{
    color: #777!important;
}
/deep/ .van-nav-bar__text{
    color:#777!important
}
section{
    overflow-x:hidden!important
}
.content {
    section{
      oveflow-x:hidden!important
    }
    img{
      max-width:100%!important;
    }
}
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
  }
  .van-swipe-item{
      height:170px;
  }
  .btn{
    width: 92px;
    background: #03a9f4;
    font-size: 13px;
    color: #fff;
    padding: 5px 15px;
    border-radius: 5px;
    text-align: center;
  }
  .amite{
    width: 100px;
    background: #03a9f4;
    color: #fff;
    border-radius: 3px;
    text-align: center;
    font-size: 13px;
    height: 27px;
    line-height: 27px;
    margin: auto;
    margin-top:10px
  }
  /deep/ .van-button--small{
    width: 90px!important;
    height:25px!important;
    border-radius: 5px!important;
  }
  /deep/ .van-nav-bar .van-icon{
    color: #777!important;
    font-size: 20px;
}
.act {
  margin-left:5px
}
</style>
<style lang="stylus" scoped>
  @import "../static/css/global.styl"
  .courseWrap
    color #333
    padding 10px
    font-size 14px
    flex-direction column
    .noData
      height 40px
    .courseWrap_header
      width 100%
      display flex
      align-items center
      justify-content space-between
      margin 10px 0
      >span
        font-weight 700
        font-size 16px
      .more
        font-size 14px
        color #999
        display flex
        cursor: pointer;
        align-items center
        .iconfont
          line-height 14px
    .courseList
      margin-top 10px
      width 100%
      li
        display flex
        justify-content space-between
        width 100%
        /*height 120px*/
        margin-bottom 14px
        &:last-child
          margin-bottom 0
        >div
          width 50%
          flex-shrink 0
        .imgWrap
          height 104px
          overflow hidden
          display flex
          align-items center
          justify-content center
          img
            width auto
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .courseList_info
          padding 2px 0 0 10px
          .courseList_info-title
            font-size 15px
            color #666
            font-weight 700
          .explain
            line-height 22px
          .intro
            color #999
            font-size 12px
            line-height 17px
            margin-top 6px
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
    .course_vtc
      display flex
      flex-wrap wrap
      width 100%
      justify-content space-between
      li
        width 175px
        margin-top 10px
        .topImg
          width 100%
          height 100px
          overflow hidden
          margin-bottom 4px
          display flex
          align-items center
          justify-content center
          .van-image
            width 100%
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .name,.age,.brief
          padding 0 6px
        .age
          color #999
          font-size 12px
          margin 8px 0
        .brief
          margin-bottom 10px
          color #999
          font-size 12px
          line-height 16px
        .ellipsis
          max-width 100%
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
.teacherWrap
    color #333
    padding 10px
    font-size 14px
    flex-direction column
    .teacherWrap_header
      width 100%
      display flex
      align-items center
      justify-content space-between
      margin 10px 0
      >span
        font-weight 700
        font-size 16px
      .more
        font-size 14px
        color #999
        display flex
        cursor: pointer;
        align-items center
        .iconfont
          line-height 14px
    .teacherList
      width 100%
      display -webkit-box
      overflow-x auto
      & >>> .van-empty
        margin 0 auto
      .teacherItem
        padding-bottom 6px
        width 100px
        display flex
        margin-right 10px
        flex-direction column
        .name
          margin 6px 0
          font-size 14px
          color #666
          font-weight 700
        >p
          color #999
          font-size 14px
@import "../static/css/global.styl"
.view_card
  color #333 !important
  padding 20px 10px
  flex-direction column
  align-items flex-start !important

  .title
    margin-bottom 10px

  .contact_item
    margin-top 10px
    display flex
    align-items center
    > span
      line-height 20px
      font-size 14px

    .iconfont
      margin-top 3px
      color #999
      margin-right 10px

    .dist
      color $bgColor
@import "../static/css/global.styl"
.usWrap
  position relative
  .usCont
    width 100%
    margin-top 26px
    position relative
    border-radius 10px
    .headTitle
      display flex
      align-items center
      justify-content center
      & > p
        margin 0 10px
        font-size 14px
      .title_img
        width 48px
        height 16px
        background url("https://sucai.weizaojiao.cn/img/org-title-info.png") no-repeat center
        background-size 100% auto
        &:last-of-type
          transform rotate(-180deg)
    .content
      width 100%
      min-height 200px
      padding 10px
      >>>img
        max-width 100%
        height auto
</style>
<style lang="stylus" scoped>
@import "../static/css/global.styl"
.usWrap
  position relative
  .usCont
    width 100%
    margin-top 26px
    position relative
    border-radius 10px
    .headTitle
      display flex
      align-items center
      justify-content center
      & > p
        margin 0 10px
        font-size 14px
      .title_img
        width 48px
        height 16px
        background url("https://sucai.weizaojiao.cn/img/org-title-info.png") no-repeat center
        background-size 100% auto
        &:last-of-type
          transform rotate(-180deg)
    .content
      width 100%
      min-height 200px
      padding 10px
      >>>img
        max-width 100%
        height auto
</style>
<style lang="less">
.content btmBrief{
  max-width:100%!important;
}
</style>